import script from "./FAQsection_prp_home.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQsection_prp_home.vue?vue&type=script&setup=true&lang=js"

import "./FAQsection_prp_home.vue?vue&type=style&index=0&id=0045db0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0045db0e"]])

export default __exports__